module.exports = __webpack_public_path__ + "img/jindo-symbol.01355e32.png";